import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAssessment } from "providers/Assessment";
import { Button } from "components/ui";
import { useTranslation } from "lib/i18n/use-translation";
import styles from "./assessment.module.scss";
import Logo from "Assets/images/logo.svg";
import ExitIcon from "Assets/icon/icon_close.svg";
import { AssessmentModal } from "../../components/modals";
import { logAnalyticsEvent } from "utility/FirebaseAnalytics";
import { AssessmentEvent } from "providers/Assessment";

const AssessmentSubmissionError = () => {
  const {
    onSubmit,
    isLoadingResults,
    reportAssessmentEvent,
    assessmentVersion,
  } = useAssessment();
  const navigate = useNavigate();
  const { t } = useTranslation(["assessment"]);
  const [isExitAssessmentModalOpen, setIsExitAssessmentModalOpen] =
    useState<boolean>(false);

  const userID = localStorage.getItem("userID");
  const companyName = localStorage.getItem("companyName") || "NA";

  const logExitAssessment = async () => {
    const params = {
      assessment_version: assessmentVersion,
      step_id: "error_screen",
      step_type: "ErrorScreen",
    };

    await logAnalyticsEvent("exit_assessment", {
      user_id: userID,
      user_id_wone: userID,
      company_name: companyName,
      ...params,
    });

    reportAssessmentEvent({
      eventType: AssessmentEvent.ExitAssessment,
      params,
    });
  };

  const handleExitAssessment = async () => {
    await logExitAssessment();
    navigate("/user/home");
  };
  return (
    <div className={styles["assessment-submission-error-container"]}>
      <div className={styles["assessment-exit-button"]}>
        <img
          src={ExitIcon}
          alt="Exit assessment button"
          onClick={() => setIsExitAssessmentModalOpen(true)}
        />
      </div>
      <div className={styles["assessment-submission-error"]}>
        <Link to="/">
          <img src={Logo} alt="WONE Logo" className={styles["logo"]} />
        </Link>

        <p>{t("assessment:error.message")}</p>
        <Button
          onClick={onSubmit}
          loading={isLoadingResults}
          variant="primary"
          className={styles["assessment-submission-error-btn"]}
        >
          {t("assessment:error.resubmit")}
        </Button>
      </div>

      {isExitAssessmentModalOpen && (
        <AssessmentModal
          subtitle={t("assessment:exitConfirm.title")}
          onYes={handleExitAssessment}
          onNo={() => setIsExitAssessmentModalOpen(false)}
        />
      )}
    </div>
  );
};

export default AssessmentSubmissionError;
